import { useEffect, useState } from 'react';
import CompanyList from './CompanyList';
import RequestCompanyList from './RequestCompanyList';
import { faArchive, faBell, faPlay } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import CompanyModal from './CompanyModal';
import axios from 'axios';
import TabBar from '../../../components/ui/TabBar';
import { loadArchive } from '../../../reducers/models/company/companyList';
import ModalAdd from '../../../components/modal/ModalAdd';
import ErrorAdd from '../../../util/ErrorAdd';

function Index() {

  //TAB START
  const [tab, setTab] = useState([
    { id_tab: 2, name: "Приглашения", icon: faBell, showCount: true, count: 0 }
    , { id_tab: 1, name: "Активные", icon: faPlay, showCount: false }
    , { id_tab: 0, name: "Архив", icon: faArchive, showCount: false }
  ]);

  const [tabSelected, setTabSelected] = useState(1);
  //TAB END

  const [modalAddShow, setModalAddShow] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [addLog, setAddLog] = useState(null);
  const [modalEditShow, setModalEditShow] = useState(false);
  const [idSelected, setIdSelected] = useState(null);

  const [loadingArchive, setLoadingArchive] = useState(false);

  const dispatch = useDispatch()

  const stateCompanyList = useSelector((state) => state.companyList);//Информация о компаниях
  const stateSetting = useSelector((state) => state.setting);//Настройки приложения 

  useEffect(() => {
    if (stateCompanyList.listInRequest !== null) {
      setTab(tab.map(t => {
        if (t.id_tab === 2) {
          return { ...t, count: stateCompanyList.listInRequest.length }
        }
        else {
          return t;
        }
      }))
    }
  }, [stateCompanyList.listInRequest]);

  function tabHandler(id_tab) {
    setTabSelected(id_tab);

    //Подгружаем архив
    if (id_tab === 0 & stateCompanyList.listArchiveLoaded === false) {
      setLoadingArchive(true);

      axios.get('/api_main/company/list', { params: { ID_Status: 0 } })
        .then((comp) => {
          dispatch(loadArchive({ company: comp.data.Data }));
          setLoadingArchive(false);
        })
        .catch((err) => {
          ErrorAdd(err, window.location.href);
          setLoadingArchive(false);
        });
    }
  }

  function companyEditHandler(id) {
    setIdSelected(id);
    setModalEditShow(true);
  }

  function addHandler(name) {
    setAddLoading(true);
    setAddLog(null);

    if (name === null) {
      setAddLog('Введите название метки');
      setAddLoading(false);
    }
    else {
      axios.post('/api_main/company/add', { Name: name })
        .then((res) => {
          if (res.data.Status === 1) {
            getNew(res.data.Data);
          }
          else {
            setAddLoading(false);
            setAddLog(res.data.Error);
          }
        })
        .catch((err) => {
          setAddLog('Неизвестная ошибка!');
          setAddLoading(false);
          ErrorAdd(err, window.location.href);
        });
    }
  }

  function getNew(id) {
    axios.get('/api_main/company/get', { params: { ID: id } })
      .then((res) => {
        if (res.data.Status == 1) {
          setIdSelected(res.data.Data.ID);
          setModalAddShow(false);
          setModalEditShow(true);
          setAddLoading(false);
        }
        else {
          setAddLoading(false);
          setAddLog(res.Error);
        }
      })
      .catch((err) => {
        setAddLog('Неизвестная ошибка!');
        setAddLoading(false);
        ErrorAdd(err, window.location.href);
      });
  }

  return (
    <div className='admin_content'>
      {modalAddShow === true && (<ModalAdd show={modalAddShow} onHide={() => setModalAddShow(false)} title='Добавление компании' loading={addLoading} error={addLog} updateHandler={addHandler} />)}
      {modalEditShow === true && (<CompanyModal show={modalEditShow} onHide={() => setModalEditShow(false)} idCompany={idSelected} model={stateCompanyList.list.filter(a => a.ID === idSelected)[0]} />)}
      <div className="mb-20">
        <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} showAdd={true} setAddShow={setModalAddShow} showFilter={false} />
      </div>
      {tab.map(tab => (
        <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""}>
          <div className="mt-20">
            {
              <>
                {tabSelected === 1 && (<CompanyList list={stateCompanyList.list.filter(a => a.ID_Status === 1).sort((a, b) => a.Name.localeCompare(b.Name))} compnaySelectedId={stateSetting.user !== null && stateSetting.user.ID_Company_Selected} editHandler={(id) => companyEditHandler(id)} />)}
                {tabSelected === 0 && (loadingArchive === true ? (<div className="loader_01 mt-30"></div>) : (<CompanyList list={stateCompanyList.list.filter(a => a.ID_Status === 0)} compnaySelectedId={stateSetting.user !== null && stateSetting.user.ID_Company_Selected} editHandler={(id) => companyEditHandler(id)} />))}
                {tabSelected === 2 && (<RequestCompanyList list={stateCompanyList.listInRequest} />)}
              </>
            }
          </div>
        </div>
      ))
      }
    </div>
  );
}

export default Index;
